export enum PortalMessage{
    USER_LOGGED_IN = "triggered by Contact us on API Portal - as logged user",
    USER_LOGGED_OUT = "triggered by Contact us on API Portal - as new request",
    SUBSCRIPTION_REQUEST = "triggered by Commercial offer (subscription request)"
}